import { ISaveCargoHabilidadeUseCase } from "../../../presentation/useCases/create/save_cargo_habilidade_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * SaveCargoHabilidadeUseCase
 */

export class SaveCargoHabilidadeUseCase implements ISaveCargoHabilidadeUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async saveCargoHabilidade(
    idHabilidade: number,
    cargoIds: number[],
  ): Promise<void> {
    await this.repository.saveCargoHabilidade(
      idHabilidade,
      cargoIds,
    );
  }
}
